/** Signal quality limits. SNR/RSS in their native units; LQ (nrsrq) differs by firmware. */
export const SIGNAL_THRESHOLDS = {
	snrMin: 3,
	rssMin: -110,
	/** GroundCast (DRS611) tolerates a higher floor. */
	rssMinGroundCast: -100,
	lqMinOldFirmware: 15,
	lqMinNewFirmware: -12,
	/** Minimum samples for a signal test to be considered valid. */
	minSignalTestSamples: 30,
} as const

/** Message availability percent. Green = healthy, yellow = warning, below = error. */
export const UPTIME_THRESHOLDS = {
	greenPercent: 97,
	yellowPercent: 93,
} as const

/** Internal battery voltage limits (volts). AtmoCast (CXT530) is solar and runs lower. */
export const VOLTAGE_THRESHOLDS = {
	avg30dMin: 6.8,
	avg30dMinAtmoCast: 6,
	min30dMin: 4.5,
} as const

export const BATTERY_THRESHOLDS = {
	/** Modem active time above this signals a battery issue (hours). No limit for AtmoCast. */
	activeTimeLimitHours: 1200,
	/** Total expected modem lifetime, used to project remaining sensor life (hours). */
	modemLifetimeHours: 1300,
} as const

export const LIFECYCLE_THRESHOLDS = {
	/** An offline device within this window is assumed to be recovering, not failed (hours). */
	offlineRecoveryHours: 48,
	/** A min-voltage metric older than this is treated as stale (days). */
	staleMetricDays: 30,
	/** Device age above this makes battery replacement (vs ECR) the recommended action (years). */
	batteryReplaceAgeYears: 1.5,
	/** Assumed total lifetime when active-time projection is unavailable (years). */
	fallbackLifetimeYears: 3,
	/** Ambient temp below this puts AtmoCast (CXT530) into hibernation (°C). */
	hibernationTempC: -20,
} as const

export const PRODUCT_CODES = {
	atmoCast: 'CXT530',
	groundCast: 'DRS611',
	fmp103: 'FMP103',
} as const

export const isAtmoCast = (device?: { productCode?: string }) => device?.productCode?.includes(PRODUCT_CODES.atmoCast) ?? false
export const isGroundCast = (device?: { productCode?: string }) => device?.productCode?.includes(PRODUCT_CODES.groundCast) ?? false

/** Solar-powered products are excluded from battery-lifetime projection. */
export const SOLAR_POWERED_PRODUCTS: string[] = [PRODUCT_CODES.atmoCast]
